import { ColorName } from '~/models/Content/Color'

export function colorIsLight(color: string) {
    let r, g, b: number
    if (color.charAt(0) === '#') {
        const colorHex = +('0x' + color.slice(1))

        if (color.length < 5) {
            colorHex.toString().replace(/./g, '$&$&')
        }

        r = colorHex >> 16
        g = colorHex >> 8 & 255
        b = colorHex & 255
    } else {
        const splitColor = color.split(' ')
        r = Number(splitColor[0])
        g = Number(splitColor[1])
        b = Number(splitColor[2])
    }

    const hsp = Math.sqrt(
        0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b),
    )

    return (hsp > 127.5)
}

// Generated subset of css custom props
export const colors: string[] = (() => {
  const ret: string[] = []
    const colorList = ['yellow', 'orange', 'redpink', 'coral', 'violet', 'purple', 'blue', 'lightblue', 'seagreen', 'green']
    colorList.forEach((color) => {
    [10, 20].forEach((shade) => {
        ret.push(`--au-${color}-${shade}`)
    })
  })
  return ret
})()

// Returns a color from the given list, indexed by the given id property
export const getColorForId = (_id: string | number, colors: string[]) => {
  const id = String(_id)
  let hash = 0
  for (let i = 0; i < id.length; i++) {
    const char = id.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash |= 0 // Convert to 32bit integer
  }
  // Use the absolute value of the hash to ensure a positive index
  // Use modulo to loop back within the range of the color array length
  const index = Math.abs(hash) % colors.length
  return colors[index]
}

export const colorMap = new Map<ColorName, { name: string; rgb: string; var: string }>([
  [ColorName.White, {
    name: 'white',
    rgb: 'rgb(255 255 255)',
    var: '--au-white',
  }],
  [ColorName.Black, {
    name: 'black',
    rgb: 'rgb(0 0 0)',
    var: '--au-black',
  }],
  [ColorName.Yellow10, {
    name: 'yellow-10',
    rgb: 'rgb(255 250 233)',
    var: '--au-yellow-10',
  }],
  [ColorName.Yellow20, {
    name: 'yellow-20',
    rgb: 'rgb(254 243 199)',
    var: '--au-yellow-20',
  }],
  [ColorName.Yellow30, {
    name: 'yellow-30',
    rgb: 'rgb(249 225 109)',
    var: '--au-yellow-30',
  }],
  [ColorName.Yellow40, {
    name: 'yellow-40',
    rgb: 'rgb(234 201 58)',
    var: '--au-yellow-40',
  }],
  [ColorName.Yellow50, {
    name: 'yellow-50',
    rgb: 'rgb(125 114 72)',
    var: '--au-yellow-50',
  }],
  [ColorName.Orange10, {
    name: 'orange-10',
    rgb: 'rgb(255 243 234)',
    var: '--au-orange-10',
  }],
  [ColorName.Orange20, {
    name: 'orange-20',
    rgb: 'rgb(255 218 172)',
    var: '--au-orange-20',
  }],
  [ColorName.Orange30, {
    name: 'orange-30',
    rgb: 'rgb(242 154 70)',
    var: '--au-orange-30',
  }],
  [ColorName.Orange40, {
    name: 'orange-40',
    rgb: 'rgb(198 129 67)',
    var: '--au-orange-40',
  }],
  [ColorName.Orange50, {
    name: 'orange-50',
    rgb: 'rgb(129 88 56)',
    var: '--au-orange-50',
  }],
  [ColorName.RedPink10, {
    name: 'redpink-10',
    rgb: 'rgb(255 243 244)',
    var: '--au-redpink-10',
  }],
  [ColorName.RedPink20, {
    name: 'redpink-20',
    rgb: 'rgb(254 224 227)',
    var: '--au-redpink-20',
  }],
  [ColorName.RedPink30, {
    name: 'redpink-30',
    rgb: 'rgb(252 99 113)',
    var: '--au-redpink-30',
  }],
  [ColorName.RedPink40, {
    name: 'redpink-40',
    rgb: 'rgb(208 91 103)',
    var: '--au-redpink-40',
  }],
  [ColorName.RedPink50, {
    name: 'redpink-50',
    rgb: 'rgb(170 46 71)',
    var: '--au-redpink-50',
  }],
  [ColorName.Coral10, {
    name: 'coral-10',
    rgb: 'rgb(252 235 235)',
    var: '--au-coral-10',
  }],
  [ColorName.Coral20, {
    name: 'coral-20',
    rgb: 'rgb(246 206 205)',
    var: '--au-coral-20',
  }],
  [ColorName.Coral30, {
    name: 'coral-30',
    rgb: 'rgb(218 82 86)',
    var: '--au-coral-30',
  }],
  [ColorName.Coral40, {
    name: 'coral-40',
    rgb: 'rgb(180 76 80)',
    var: '--au-coral-40',
  }],
  [ColorName.Coral50, {
    name: 'coral-50',
    rgb: 'rgb(143 67 72)',
    var: '--au-coral-50',
  }],
  [ColorName.Violet10, {
    name: 'violet-10',
    rgb: 'rgb(239 223 235)',
    var: '--au-violet-10',
  }],
  [ColorName.Violet20, {
    name: 'violet-20',
    rgb: 'rgb(227 188 216)',
    var: '--au-violet-20',
  }],
  [ColorName.Violet30, {
    name: 'violet-30',
    rgb: 'rgb(176 96 157)',
    var: '--au-violet-30',
  }],
  [ColorName.Violet40, {
    name: 'violet-40',
    rgb: 'rgb(135 35 114)',
    var: '--au-violet-40',
  }],
  [ColorName.Violet50, {
    name: 'violet-50',
    rgb: 'rgb(111 34 96)',
    var: '--au-violet-50',
  }],
  [ColorName.Purple10, {
    name: 'purple-10',
    rgb: 'rgb(232 229 243)',
    var: '--au-purple-10',
  }],
  [ColorName.Purple20, {
    name: 'purple-20',
    rgb: 'rgb(209 204 231)',
    var: '--au-purple-20',
  }],
  [ColorName.Purple30, {
    name: 'purple-30',
    rgb: 'rgb(149 113 166)',
    var: '--au-purple-30',
  }],
  [ColorName.Purple40, {
    name: 'purple-40',
    rgb: 'rgb(101 57 124)',
    var: '--au-purple-40',
  }],
  [ColorName.Purple50, {
    name: 'purple-50',
    rgb: 'rgb(84 51 103)',
    var: '--au-purple-50',
  }],
  [ColorName.Blue10, {
    name: 'blue-10',
    rgb: 'rgb(234 240 249)',
    var: '--au-blue-10',
  }],
  [ColorName.Blue20, {
    name: 'blue-20',
    rgb: 'rgb(204 217 239)',
    var: '--au-blue-20',
  }],
  [ColorName.Blue30, {
    name: 'blue-30',
    rgb: 'rgb(61 112 167)',
    var: '--au-blue-30',
  }],
  [ColorName.Blue40, {
    name: 'blue-40',
    rgb: 'rgb(28 74 123)',
    var: '--au-blue-40',
  }],
  [ColorName.Blue50, {
    name: 'blue-50',
    rgb: 'rgb(23 43 84)',
    var: '--au-blue-50',
  }],
  [ColorName.LightBlue10, {
    name: 'lightblue-10',
    rgb: 'rgb(226 241 247)',
    var: '--au-lightblue-10',
  }],
  [ColorName.LightBlue20, {
    name: 'lightblue-20',
    rgb: 'rgb(204 227 236)',
    var: '--au-lightblue-20',
  }],
  [ColorName.LightBlue30, {
    name: 'lightblue-30',
    rgb: 'rgb(77 158 195)',
    var: '--au-lightblue-30',
  }],
  [ColorName.LightBlue40, {
    name: 'lightblue-40',
    rgb: 'rgb(1 115 159)',
    var: '--au-lightblue-40',
  }],
  [ColorName.LightBlue50, {
    name: 'lightblue-50',
    rgb: 'rgb(20 71 95)',
    var: '--au-lightblue-50',
  }],
  [ColorName.SeaGreen10, {
    name: 'seagreen-10',
    rgb: 'rgb(226 239 241)',
    var: '--au-seagreen-10',
  }],
  [ColorName.SeaGreen20, {
    name: 'seagreen-20',
    rgb: 'rgb(212 235 236)',
    var: '--au-seagreen-20',
  }],
  [ColorName.SeaGreen30, {
    name: 'seagreen-30',
    rgb: 'rgb(110 174 183)',
    var: '--au-seagreen-30',
  }],
  [ColorName.SeaGreen40, {
    name: 'seagreen-40',
    rgb: 'rgb(61 126 128)',
    var: '--au-seagreen-40',
  }],
  [ColorName.SeaGreen50, {
    name: 'seagreen-50',
    rgb: 'rgb(9 84 86)',
    var: '--au-seagreen-50',
  }],
  [ColorName.Green10, {
    name: 'green-10',
    rgb: 'rgb(235 243 241)',
    var: '--au-green-10',
  }],
  [ColorName.Green20, {
    name: 'green-20',
    rgb: 'rgb(204 225 220)',
    var: '--au-green-20',
  }],
  [ColorName.Green30, {
    name: 'green-30',
    rgb: 'rgb(77 156 139)',
    var: '--au-green-30',
  }],
  [ColorName.Green40, {
    name: 'green-40',
    rgb: 'rgb(0 106 82)',
    var: '--au-green-40',
  }],
  [ColorName.Green50, {
    name: 'green-50',
    rgb: 'rgb(0 66 62)',
    var: '--au-green-50',
  }],
  [ColorName.Gray10, {
    name: 'gray-10',
    rgb: 'rgb(240 240 240)',
    var: '--au-gray-10',
  }],
  [ColorName.Gray20, {
    name: 'gray-20',
    rgb: 'rgb(212 212 212)',
    var: '--au-gray-20',
  }],
  [ColorName.Gray30, {
    name: 'gray-30',
    rgb: 'rgb(168 168 168)',
    var: '--au-gray-30',
  }],
  [ColorName.Gray40, {
    name: 'gray-40',
    rgb: 'rgb(101 101 101)',
    var: '--au-gray-40',
  }],
  [ColorName.Gray50, {
    name: 'gray-50',
    rgb: 'rgb(71 71 71)',
    var: '--au-gray-50',
  }],
])
